import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [

  {
    path: "/",
    name: "Index",
    component: () =>
      import("../views/Index.vue"),
  },
  {
    path: "/leave",
    name: "Leave",
    component: () =>
      import("../views/leave.vue"),
  },
  {
    path: "/pdf",
    name: "Pdf",
    component: () =>
      import("../views/Pdf.vue"),
  },
  {
    path: "/contract",
    name: "Contract",
    component: () =>
      import("../views/contract.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
